import { useCallback, useState } from 'react';
export default (function (storage) { return function (key, initialValue) {
    var _a = useState(function () {
        try {
            var item = window[storage].getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            console.log(error);
            return initialValue;
        }
    }), storedValue = _a[0], setStoredValue = _a[1];
    var setValue = useCallback(function (value) {
        try {
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window[storage].setItem(key, JSON.stringify(valueToStore));
        }
        catch (error) {
            console.log(error);
        }
    }, [key, storedValue]);
    return [storedValue, setValue];
}; });
//# sourceMappingURL=useStorage.js.map